module.exports = __webpack_public_path__ + "static/slide-6-3790278ece4861e7606d486f956ea55d.svg";